module.exports = __webpack_public_path__ + "home-01.png?fbe04c7c2ae6bc643ff3c57db272d735";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wap/home-01.png
// module id = 172
// module chunks = 0